<template>
    <router-view class="bg-white w-full flex flex-col"></router-view>
</template>

<script>
    export default {
        beforeUpdate() {
            //this.$Progress.start();
        }
    }
</script>
